import React from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button
} from "reactstrap";
import "../../styles/estilos.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { limpiarTotalesHogar } from "../../redux/actions/ACarritoProductos";

class ValoresCotizacionGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.state = {         
      height: window.innerHeight,
      claseDivFix: "flex-row div-flotante" ,              
    }
    this.handleScroll = this.handleScroll.bind(this);    
  }

  onClick = async (event) => {
    event.preventDefault();
    this.props.history.replace({
      pathname: "/lista-cotizadores",
    });
  }

  onClickReintentarPago = (event) => {    
    event.preventDefault();
    const {datosAdicionales} = this.props;
    if(datosAdicionales.urlReintentarPago)
    {
      //console.log("Entre a evento onCLik Reintentar pago", datosAdicionales.urlReintentarPago)
      //window.location.href='http://www.w3schools.com';
      window.location.href=datosAdicionales.urlReintentarPago;
    }
    
  }


  /* Eventos Scroll */
  handleScroll() {
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
    if (this.props.paso === "resumen-cotizacion") {      
      if (this.props.detalleCarrito && this.props.detalleCarrito.productosCarrito.carProductos.length > 1) {
        if (windowBottom >= (docHeight - 300)) {
          this.setState({
            claseDivFix: 'flex-row div-flotante fix-botton-totales-resumen-multi'
          });
        } else {
          this.setState({
            claseDivFix: 'flex-row div-flotante'
          });
        }
      }
      else {
        if (windowBottom >= (docHeight - 300)) {
          this.setState({
            claseDivFix: 'flex-row div-flotante fix-botton-totales-resumen'
          });
        } else {
          this.setState({
            claseDivFix: 'flex-row div-flotante'
          });
        }
      }
    }
    else {
      if (windowBottom >= (docHeight - 120)) {
        this.setState({
          claseDivFix: 'flex-row div-flotante fix-botton-totales'
        });        
      } else {
        this.setState({
          claseDivFix: 'flex-row div-flotante'
        });
      }
    }
  }

  async componentDidMount() {
    await this.props.limpiarTotalesHogar();
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    let { valorTotal, estado } = this.props;
    const { claseDivFix } = this.state;    
    let total = {
      prima_neta_anual_full_cobertura: "0.00",
      super_bancos_Full_Cobertura: "0.00",
      seguro_campesino_Full_Cobertura: "0.00",
      derecho_emision_Full_Cobertura: "0.00",
      primaTotal_Full_Cobertura: "0.00",
      iva_Full_Cobertura: "0.00",
      totalImpuestos: "0.00"
    }
      
    if(valorTotal && valorTotal !== undefined )
    {
        total.prima_neta_anual_full_cobertura=valorTotal.prima_neta_anual_full_cobertura
        total.super_bancos_Full_Cobertura=valorTotal.super_bancos_Full_Cobertura
        total.seguro_campesino_Full_Cobertura=valorTotal.seguro_campesino_Full_Cobertura
        total.derecho_emision_Full_Cobertura=valorTotal.derecho_emision_Full_Cobertura
        total.iva_Full_Cobertura=valorTotal.iva_Full_Cobertura
        total.totalImpuestos=valorTotal.totalImpuestos
        total.primaTotal_Full_Cobertura=valorTotal.totalcarrito
    }
    
    
    //Validaciones de texto de boton
    let textoBoton = "NUEVA COTIZACIÓN";
    let claseBoton = "btn btn-primary";
     

    //Fin Validaciones de texto de boton
    return (
      <Card className={claseDivFix}>
        <CardBody>
          <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <h5>Prima Neta</h5>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <h5>${total.prima_neta_anual_full_cobertura}</h5>
            </Col>
          </Row>
          <Row>
            <div id="container-imp">
              <div className="accordion-imp">
                <input type="checkbox" id="tm" />
                <label htmlFor="tm" className="accordionitem">
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5 title={"Presiona click para ver/ocultar el detalle impuestos"} >
                        Impuestos{" "}
                        <i
                          className="fa fa-info-circle"
                          aria-hidden="true"
                        />
                      </h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.totalImpuestos}</h5>
                    </Col>
                  </Row>
                </label>
                <div className="hiddentext ocultar">
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>IVA</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.iva_Full_Cobertura}</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>Super bancos 3.5 %</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.super_bancos_Full_Cobertura}</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>Seguro Campesino</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.seguro_campesino_Full_Cobertura}</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>Derechos de Emisión</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.derecho_emision_Full_Cobertura}</h5>
                    </Col>
                  </Row>

                </div>
                
              </div>
            </div>
          </Row>
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
              <h5 style={{ fontWeight: "bold" }}>Prima Total</h5>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
              <h5 style={{ fontWeight: "bold" }}>${total.primaTotal_Full_Cobertura}</h5>
            </Col>
          </Row>
          <hr />
          <Button
            className={claseBoton}
            onClick={this.onClick}
            style={{ display: "block", margin: "auto" }}
            disabled={false}
          >
            <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
            {textoBoton}
          </Button>
          <p></p>
          {estado && estado === "RECHAZADO" && 
              <Button
                    className={
                      "btn btn-primary btn-purple"
                    }
                    onClick={this.onClickReintentarPago}
                    style={{ display: "block", margin: "auto" }}
                  >
                    <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                    {"REINTENTAR PAGO"}
              </Button>
          }
          
          <p></p>
          
        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  
  datosCarritoHogar : state.datosCarritoHogar,
  dataUsuario: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = dispatch => {
  return {
    limpiarTotalesHogar: () => dispatch(limpiarTotalesHogar()),
    
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ValoresCotizacionGeneral)
);
